import { regex } from '../../node_modules/vuelidate/lib/validators/common'
export default regex('kana', /^[ァ-ンー\s]+$/)



// WEBPACK FOOTER //
// ./src/validators/kana.js